import { isEmpty } from 'lodash';

export default ({ address, user = {}, showName = true, showUserName }) => {
	const firstname = (!isEmpty(user) ? user.firstname : address.firstname) || '';
	const surname = (!isEmpty(user) ? user.surname : address.surname) || '';

	let name = '';
	if (showName) {
		name = address.company || '';
	} else if (firstname || surname) {
		name = ((firstname && '') + ' ' + (surname && '')).trim() || '';
	}

	if (showUserName) {
		name = '';
		if (address.firstname !== '' && address.firstname !== undefined && address.firstname !== null) {
			name += address.firstname + ', ';
		}
		if (address.surname !== '' && address.surname !== undefined && address.surname !== null) {
			name += address.surname + ', ';
		}
		if (address.company !== '' && address.company !== undefined && address.company !== null) {
			name += address.company + ', ';
		}
	}

	return [
		name && name + ',',
		// address.country_code && translate ? translate('countries.' + address.country_code) + ',' : '',
		address.street || '',
		address.house_number + ',' || '',
		address.postal_code || '',
		address.city || ''
	]
		.filter(Boolean)
		.filter(String)
		.join(' ');
};
